import { Button, Modal } from "@mui/material";
import styles from "./FavoriteButton.module.scss";
import { useEffect, useRef, useState } from "react";
import useFavoriteItem from "Explore/Hook/useFavoriteItem";
import { useSelector } from "react-redux";
import LoginBox from "LandingPage/Components/LoginBox";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteSnackbar from "Explore/Hook/FavoriteItemSnackbar";
import classNames from "classnames";

const FavoriteButton = ({ isFavorited: _isFavorited, itemId, itemType }) => {
  const user = useSelector((state) => state.user.data);
  const { createFavoriteItem, deleteFavoriteItem, snackbarProps } =
    useFavoriteItem({ itemId, itemType });
  const [isFavorited, setIsFavorited] = useState(_isFavorited);
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const [simpleButton, setSimpleButton] = useState(false);

  const onClickFavorite = async () => {
    if (!user) {
      setLoginModalOpen(true);
      return;
    }
    const newIsFavorited = !isFavorited;
    try {
      if (newIsFavorited) {
        await createFavoriteItem();
      } else {
        await deleteFavoriteItem();
      }
      setIsFavorited(newIsFavorited);
    } catch (e) {
      console.log(e);
    }
  };

  const buttonRef = useRef(null);
  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      const button = buttonRef.current;
      if (!button) return;
      const { width } = button.getBoundingClientRect();
      if (width < 100) {
        setSimpleButton(true);
      } else {
        setSimpleButton(false);
      }
    });
    resizeObserver.observe(buttonRef.current);
    return () => {
      resizeObserver.disconnect();
    };
  }, [buttonRef]);

  return (
    <>
      <Button
        ref={buttonRef}
        variant="contained"
        color="secondary"
        size="small"
        className={classNames(styles["favorite-btn"], {
          [styles["favorite-btn--simple"]]: simpleButton,
        })}
        onClick={() => onClickFavorite()}
        endIcon={isFavorited ? <FavoriteIcon /> : <FavoriteBorderIcon />}
      >
        {!simpleButton && (isFavorited ? "Favorited" : "Favorite")}
      </Button>

      <Modal open={loginModalOpen} onClose={() => setLoginModalOpen(false)}>
        <div className={styles["login-modal"]}>
          <LoginBox
            title={"Sign In to View and Manage Your Favorite Selections"}
          />
        </div>
      </Modal>

      <FavoriteSnackbar {...snackbarProps} />
    </>
  );
};

export default FavoriteButton;
